import React from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Mail, ArrowLeft, Loader2, CheckCircle2 } from "lucide-react";
import { Helmet } from "react-helmet-async";

export default function ForgotPassword() {
  const [email, setEmail] = React.useState("");
  const [busy, setBusy] = React.useState(false);
  const [sent, setSent] = React.useState(false);
  const [err, setErr] = React.useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setSent(true);
    } catch (e2) {
      setErr(e2?.response?.data?.detail || "Permintaan gagal. Coba lagi.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-muted/40" data-testid="forgot-password-page">
      <Helmet><title>Lupa Password — BATIK</title></Helmet>
      <div className="w-full max-w-md bg-card border border-border rounded-lg p-8 lg:p-10 shadow-xl">
        <Link to="/login" className="inline-flex items-center gap-2 text-muted-foreground hover:text-primary text-xs mb-6">
          <ArrowLeft className="h-3.5 w-3.5" /> Kembali ke Login
        </Link>

        {sent ? (
          <div className="text-center" data-testid="forgot-success">
            <div className="h-16 w-16 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-5">
              <CheckCircle2 className="h-8 w-8 text-emerald-600" />
            </div>
            <h1 className="font-serif text-2xl text-primary mb-3">Cek Email Anda</h1>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Jika <b>{email}</b> terdaftar, kami telah mengirim tautan reset password ke email tersebut. Tautan berlaku 1 jam.
            </p>
          </div>
        ) : (
          <>
            <div className="h-12 w-12 rounded-full bg-accent/15 flex items-center justify-center mb-5">
              <Mail className="h-5 w-5 text-accent" />
            </div>
            <p className="overline mb-2">Reset Password</p>
            <h1 className="font-serif text-3xl text-primary tracking-tight leading-tight mb-3">Lupa Password?</h1>
            <p className="text-sm text-muted-foreground mb-6">Masukkan email terdaftar, kami akan kirim tautan reset password.</p>

            <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
              <div>
                <label className="text-xs uppercase tracking-wider text-muted-foreground font-medium">Email</label>
                <input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 w-full px-3 py-2.5 border border-border rounded-md bg-background text-sm focus:outline-none focus:ring-2 focus:ring-accent" placeholder="anda@email.com" autoComplete="email" />
              </div>
              {err && <p className="text-xs text-red-600">{err}</p>}
              <button type="submit" disabled={busy} data-testid="forgot-submit" className="w-full py-2.5 rounded-full bg-primary text-primary-foreground text-sm font-semibold hover:bg-primary/90 disabled:opacity-60 inline-flex items-center justify-center gap-2">
                {busy && <Loader2 className="h-4 w-4 animate-spin" />}
                Kirim Tautan Reset
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
